import { useCallback } from "react";
import { trackClickedButton } from "utils/analytics";
import { useHostPageName } from "hooks/usePageViewTracker";

// The Lessons & Standards sidebar stands in for the global nav on the pages
// that render it, so its clicks mirror the nav's `source: "Left Nav"`.
const SIDEBAR_SOURCE = "Sidebar";

// Every button_name the sidebar sends. Callers pass these rather than
// literals, so the analytics inventory can read the list in one place.
export const SIDEBAR_BUTTONS = {
  BACK_TO_GROUPS: "Back to Groups",
  MODE_TOGGLE: "Mode Toggle",
  COURSE_FILTER: "Course Filter",
  GRADE_FILTER: "Grade Filter",
  UNIT_TOGGLE: "Unit Toggle",
  MODULE_TOGGLE: "Module Toggle",
  SELECT_LESSON: "Select Lesson",
  TREE_TOGGLE: "Tree Toggle",
  SELECT_STANDARD: "Select Standard",
};

// The Lesson / Standard toggle's analytics values, by mode key.
export const SIDEBAR_MODE_LABELS = { lesson: "Lesson", standard: "Standard" };

// A grade select's value is the raw grade token ("K", "4", "HSA"), or "all".
export const sidebarGradeValue = (value) => (value === "all" ? "All Grades" : value);

export const useSidebarTracking = () => {
  const hostPageName = useHostPageName();
  return useCallback(
    (buttonName, extras = {}) =>
      trackClickedButton(buttonName, { page_name: hostPageName, source: SIDEBAR_SOURCE, ...extras }),
    [hostPageName]
  );
};
